import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface StarRatingDisplayProps {
  rating: number;
  className?: string;
}

export function StarRatingDisplay({ rating, className }: StarRatingDisplayProps) {
  return (
    <div
      role="img"
      className={cn("flex items-center gap-0.5", className)}
      aria-label={`${rating} out of 5 stars`}
    >
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          className={cn(
            "h-4 w-4",
            star <= rating ? "fill-yellow-400 text-yellow-400" : "text-muted-foreground/40"
          )}
        />
      ))}
    </div>
  );
}
